import styled from "styled-components";

export const PrincipalContainer = styled.div`
`